<template>
  <div>
    <!-- т -->
    <!-- п -->
    <v-container>
      <v-card
        width="100%"
        :class="`mx-auto ${PARTNER_CONFIG.theme_partner.cardVakans} `"
        color="#385F73"
        dark
      >
        <!-- скелетон -->
        <div v-if="ISLOAD">
          <v-skeleton-loader
            ref="skeleton"
            type="card"
            class="mx-auto"
            width="100%"
          ></v-skeleton-loader>

        </div>
        <!-- /скелетон -->

        <v-container v-if="!ISLOAD">
          <v-row
            justify="space-between"
            no-gutters
          >

            <!-- картинка вакансия -->
            <v-col
              md="6"
              xs="12"
              justify="space-between"
            >
              <v-img
                class="white--text align-end"
                :src="ONE_VACANSIJA.image"
              >
                <v-chip
                  :class="ONE_VACANSIJA.isActual"
                  color="red"
                  text-color="white"
                  big
                >
                  <v-icon>mdi-fire</v-icon>
                  Приезд {{ ONE_VACANSIJA.priezd }}
                </v-chip>
                <v-chip
                  class="ma-1"
                  :class="ONE_VACANSIJA.isBezviz"
                  color="green"
                  text-color="white"
                >
                  <v-icon>mdi-hail</v-icon>

                  Безвиз
                </v-chip>

                <v-chip
                  class="ma-1"
                  :class="ONE_VACANSIJA.isUa"
                  color="indigo"
                  text-color="white"
                >
                  <v-icon>mdi-text-box-check-outline</v-icon>

                  UA котнтракт
                </v-chip>
              </v-img>
            </v-col>
            <!--/ картинка вакансия -->

            <!-- описание -->
            <v-col
              xs="12"
              md="5"
              justify="space-between"
            >
              <h2>{{ ONE_VACANSIJA.headerVakans }}</h2>

              <div>
                <v-card-text class="category">
                  <v-icon :class="PARTNER_CONFIG.theme_partner.iconVakans">mdi-google-maps</v-icon>
                  {{ ONE_VACANSIJA.cyty }}
                </v-card-text>
              </div>

              <div>
                <v-card-text class="category">
                  <v-icon :class="PARTNER_CONFIG.theme_partner.iconVakans">mdi-cash</v-icon>
                  {{ ONE_VACANSIJA.salary }}
                </v-card-text>
              </div>
              <div>
                <v-card-text class="category">
                  <v-icon :class="PARTNER_CONFIG.theme_partner.iconVakans">mdi-clock-time-four-outline</v-icon>
                  {{ ONE_VACANSIJA.worchours }}
                </v-card-text>
              </div>

              <div>
                <v-card-text class="category">
                  <v-icon :class="PARTNER_CONFIG.theme_partner.iconVakans">mdi-human-male-female</v-icon>
                  {{ ONE_VACANSIJA.gender }}
                </v-card-text>
              </div>
              <v-card-subtitle> {{ONE_VACANSIJA.kategory}}</v-card-subtitle>

            </v-col>
            <!-- описание -->

          </v-row>

          <!-- <v-card-subtitle>
            {{ONE_VACANSIJA.kategory}}
          </v-card-subtitle> -->

          <v-expand-transition>
            <div max-width="50%">
              <v-card-text>
                <div
                  class="bodyVakans"
                  v-html="ONE_VACANSIJA.vacansBody"
                ></div>
                <div class="text-right ">
                  <v-btn
                    v-if="!webShareApiSupported"
                    fab
                    dark
                    class="btnShareVib"
                  >
                    <a
                      style="color: white"
                      :href="`viber://forward?text=${ONE_VACANSIJA.headerVakans} ${urlSite}`"
                    >

                      <v-icon dark>mdi-share-variant</v-icon>

                    </a></v-btn>

                  <v-btn
                    v-if="webShareApiSupported"
                    fab
                    dark
                    @click="shareViaWebShare(ONE_VACANSIJA)"
                    :class="PARTNER_CONFIG.theme_partner.btnShare"
                  >
                    <v-icon dark>mdi-share-variant</v-icon>
                  </v-btn>
                </div>
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

 <script>
// export default {
//   data: () => ({
//     show: false
//   })
// };
//

import { mapActions, mapGetters } from "vuex";

export default {
  name: "Vakansija",
  methods: {
    ...mapActions(["GET_ONE_VAKANSIJA_FROM_API"]),
    shareViaWebShare(vacansija) {
      console.log(vacansija);
      let textShareVakans = `${vacansija.headerVakans}

🚈 Место работы — ${vacansija.cyty}
👧👨‍🚒 ${vacansija.gender}
📄 ${vacansija.viza}
💰 оплат ${vacansija.salary}
🕒 часов ${vacansija.worchours}
      `;
      // let titleVak = titleVakans;

      let urlVakShare = "/Vakansija/" + vacansija.idVakans;

      navigator.share({
        // title: vacansija.headerVakans,
        text: textShareVakans,
        url: urlVakShare
      });
    }
  },
  computed: {
    ...mapGetters(["ONE_VACANSIJA", "ISLOAD", "PARTNER_CONFIG"]),

    webShareApiSupported() {
      return navigator.share;
    },
    urlSite() {
      return window.location.href;
    }
  },

  activated() {
    console.log("activated");
    let s = this.$route.fullPath;

    let param = s.split("/");

    if (param) {
      this.GET_ONE_VAKANSIJA_FROM_API(param[2]);
    } else {
    }
  }
};
</script>

<style lang="css" scoped>
.bodyVakans {
  width: 100%;
}
iframe {
  width: 100px;
}
.categori-icon {
  color: brown;
  background-color: chartreuse;
  width: 50%;
}
.viza {
  display: none;
}
.neUa {
  display: none;
}
.neActual {
  display: none;
}
.btnShare {
  padding: 25px;
}
a {
  text-decoration: none;
  color: red;
}
</style>